import React from 'react';
import clsx from 'clsx';
import { UnitCategoryCode, FlamingoFund, FundManagerPhotoData } from 'funds-model';
import FundDetailsDialogAbout from './FundDetailsDialogAbout';
import FundDetailsDialogCost from './FundDetailsDialogCost';
import FundDetailsDialogInformation from './FundDetailsDialogInformation';
import FundDetailsDialogWalletChart from './FundDetailsDialogWalletChart';
import FundDetailsDialogDocuments from './FundDetailsDialogDocuments';

import useStyles from './FundDetailsDialog.style';

interface FundDetailsDialogGridProps {
  fund: FlamingoFund;
  unitCategoryCode: UnitCategoryCode;
  isMobile: boolean;
  processLayout: boolean;
  getFundManagerPhotoPromise: (peopleIds: string) => Promise<FundManagerPhotoData[]>;
  className?: string;
}

const FundDetailsDialogGrid: React.FC<FundDetailsDialogGridProps> = ({ fund, unitCategoryCode, isMobile, processLayout, getFundManagerPhotoPromise, className }) => {
  const c = useStyles({processLayout});

  if (isMobile) {
    return (
      <div className={clsx(c.grid, className)}>
        <div>
          <FundDetailsDialogAbout fund={fund} />
          <FundDetailsDialogWalletChart fund={fund} unitCategoryCode={unitCategoryCode}/>
          <FundDetailsDialogInformation fund={fund} unitCategoryCode={unitCategoryCode} getFundManagerPhotoPromise={getFundManagerPhotoPromise}/>
          <FundDetailsDialogCost fund={fund} unitCategoryCode={unitCategoryCode} />
          <FundDetailsDialogDocuments fund={fund} unitCategoryCode={unitCategoryCode}/>
        </div>
      </div>
    );
  }

  return (
    <div className={clsx(c.grid, className)}>
      <div>
        <FundDetailsDialogAbout fund={fund} />
        <FundDetailsDialogInformation fund={fund} unitCategoryCode={unitCategoryCode} getFundManagerPhotoPromise={getFundManagerPhotoPromise}/>
        <FundDetailsDialogCost fund={fund} unitCategoryCode={unitCategoryCode} />
      </div>
      <div>
        <FundDetailsDialogWalletChart fund={fund} unitCategoryCode={unitCategoryCode}/>
        <FundDetailsDialogDocuments fund={fund} unitCategoryCode={unitCategoryCode}/>
      </div>
    </div>
  );
};

export default FundDetailsDialogGrid;
